// extracted by mini-css-extract-plugin
export var label = "_bu-1";
export var reminder = "_bu-0";